import React, {FC} from 'react';
import './style.scss';
import {pathSuite} from "../../../constants";
import goBack from "../../../assets/img/header/go__back--white.svg";
import {useHistory} from 'react-router-dom';
import Header from "../../Header";

interface ICompilationsTitle {
    imageUrl: string,
    title: string
}

const CompilationsTitle: FC<ICompilationsTitle> = ({
                                                       imageUrl,
                                                       title
                                                   }) => {
    const history = useHistory();
    return (
        <div
            style={{backgroundImage: `url(${pathSuite + imageUrl})`}}
            className="compilations-list__image-container"
        >
            <Header headerCompilations>
                <div className="compilations-list__header">
                    <img
                        className="standard__header-img"
                        onClick={() => history.goBack()}
                        src={goBack}
                        alt="Go Back"
                    />
                </div>
            </Header>
            <span className="compilations-list__image-title">
                    {title}
                </span>
        </div>
    )
};

export default CompilationsTitle;
